import isEmpty from 'transmute/isEmpty';
import UIList from 'UIComponents/list/UIList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import LeafNode from 'automation-ui-enrollment/components/common/jsonView/LeafNode';
import AccordionTreeRoot from 'automation-ui-enrollment/components/common/jsonView/AccordionTreeRoot';
import { jsx as _jsx } from "react/jsx-runtime";
const AccordionTree = ({
  areAllBranchesOpen,
  dataObject
}) => {
  const AccordingTreeComponents = Object.keys(dataObject).reduce((acc, key) => {
    const value = dataObject[key];
    if (typeof value === 'object' && value !== null) {
      acc.branches.push( /*#__PURE__*/_jsx(AccordionTreeRoot, {
        keyString: key,
        areAllBranchesOpen: areAllBranchesOpen,
        value: value
      }, key));
    } else {
      acc.leaves.push( /*#__PURE__*/_jsx(LeafNode, {
        jsonKey: key,
        value: String(value)
      }, key));
    }
    return acc;
  }, {
    leaves: [],
    branches: []
  });
  if (isEmpty(dataObject)) {
    return /*#__PURE__*/_jsx(UIList, {
      children: /*#__PURE__*/_jsx("em", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-action-features.action-features.webhook.testing.empty-branch"
        })
      })
    });
  }
  const OrderedAccordingTreeComponents = [...AccordingTreeComponents.leaves, ...AccordingTreeComponents.branches];
  return /*#__PURE__*/_jsx(UIList, {
    children: OrderedAccordingTreeComponents
  });
};
export default AccordionTree;